import { render, staticRenderFns } from "./Infomations.vue?vue&type=template&id=3414a422&scoped=true&"
import script from "./Infomations.vue?vue&type=script&lang=js&"
export * from "./Infomations.vue?vue&type=script&lang=js&"
import style0 from "./Infomations.vue?vue&type=style&index=0&id=3414a422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3414a422",
  null
  
)

export default component.exports